module.exports = __webpack_public_path__ + "static/media/call_end.1bf8d613.svg";